import { zIndexDialog } from '@spotify-internal/encore-web/core/styles';
export var trackCat = 'Top Nav';
export var NavBarHeight = 72;
export var NavBarHeightSmScreen = 56;
export var NavBarZIndex = zIndexDialog + 2;
export var FlyoutMenuZIndex = zIndexDialog + 1;
export var SideFlyoutTopBarZIndex = zIndexDialog + 2;
export var SideFlyoutZIndex = zIndexDialog + 1;
export var SecondaryNavZIndex = zIndexDialog;
